export interface RailLayerProps {
  opacity?: number;
  side?: "left" | "right";
  length?: string;
}

export function RailLayer({
  opacity = 1,
  side = "right",
  length = "60%",
}: RailLayerProps) {
  return (
    <div
      style={{
        position: "absolute",
        top: "20%",
        [side]: 26,
        width: 22,
        height: length,
        pointerEvents: "none",
        opacity,
        zIndex: 0,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 4,
          width: 0.75,
          background: "rgba(14,14,14,0.10)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 4,
          width: 0.75,
          background: "rgba(14,14,14,0.10)",
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "repeating-linear-gradient(180deg, transparent 0 18px, rgba(14,14,14,0.10) 18px 19px)",
          animation: `rail-drift 24s linear infinite`,
        }}
      />
    </div>
  );
}
